<template>
        <div class="container mb-2">
            <div class="card">
                <div v-if="hasHeader" class="card-header py-2 text-muted">
                    {{headerNm}}
                </div>
                <div class="card-body">
                    <div class="custom-file">
                        <input type="file" ref="fileSelect" class="custom-file-input" id="fileSelect" accept=".csv" @change="changeFile">
                        <label class="custom-file-label" for="fileSelect" data-browse="参照">{{fileLab}}</label>
                    </div>
            
                    <div class="mt-4">
                        <button class="btn btn-primary btn-block" type="button" @click="uploadFile">
                            <i class="fas fa-upload"></i>&nbsp;&nbsp;{{btnNm}}
                        </button>
                    </div>
                </div>
            </div>

            <info-msg ref="warning" :lev="1" :msg="msg"></info-msg>
        </div>
</template>

<script>
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            InfoMsg
        },
        props: {
            // ヘッダー有無
            hasHeader: {
                type: Boolean,
                defalut: false
            },
            // ヘッダー文言
            headerNm: {
                type: String,
                default: "ファイル選択"
            },
            // ボダン文言
            btnNm: {
                type: String,
                default: "アップロード"
            },
            // ファイル拡張子
            ext: Array,
            // リクエストaction名
            act: String
        },
        data () {
            return {
                fileLab: "ファイルを選択...",
                msg: ""
            }
        },
        watch: {
            getImportPostalCsvStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startSpinner')
                }
                if (status == '2') {
                    this.resetThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == '3') {
                    this.resetThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getImportPostalCsvStatus'])
        },
        methods: {
            doUpload (formData) {
                this.$store.dispatch(this.act, formData)
            },
            changeFile () {
                if (!this.checkExt()) {
                    this.openMsg()
                }
            },
            uploadFile () {
                if (this.checkExist()) {
                    let formData = new FormData();
                    formData.append('fileData', this.$refs.fileSelect.files[0])
                    this.doUpload(formData)
                } else {
                    this.openMsg()
                }
            },
            resetThis () {
                let fileInput = this.$refs.fileSelect.value = ""
                this.fileLab = "ファイルを選択..."
            },
            checkExt () {
                let fileInput = this.$refs.fileSelect
                let fileName = fileInput.files[0].name
                if (!this.doCheckExt(fileName)) {
                    this.resetThis()
                    return false
                } 
                this.fileLab = fileName
                return true
            },
            checkExist () {
                let fileInput = this.$refs.fileSelect
                return fileInput.value ? true : false
            },
            doCheckExt (filename) {
                var flag = false; 
                var arr = this.ext;
                var index = filename.lastIndexOf(".");
                var ext = filename.substr(index+1);
                for (var i = 0; i < arr.length; i++)
                {
                    if(ext == arr[i])
                    {
                        flag = true; 
                        break;
                    }
                }
                return flag;
            },
            openMsg () {
                var arr = this.ext
                var msg = "拡張子は【"
                for (var i = 0; i < arr.length; i++) {
                    if (i == arr.length - 1) {
                        msg += arr[i] + '】のファイルを選択してください。'
                    } else {
                        msg += arr[i] + '、 '
                    }
                }
                this.msg = msg
                this.$refs.warning.openThis()
            }
        }
    }
</script>

<style>

</style>
